module.exports = __webpack_public_path__ + "static/logo-dark-aa0d40ec8ea3137c297e495d5626e445.png";